module.exports = __webpack_public_path__ + "img/icon_Line.b08f08b6.svg";